import { SplitLayout } from '@coachhubio/nova-layout';
import { Skeleton } from '@coachhubio/nova-skeleton';
import Footer from 'components/Footer';

import { useDashboard } from './context/DashboardContext';
import { DashboardSections } from './DashboardSections';
import { DashboardSectionsNoInsightsLayout } from './DashboardSectionsNoInsightsLayout';
import { DashboardSidebar } from './DashboardSidebar';
import { StyledColumn } from './LookerDashboardSideBar.styles';

export const DashboardSectionsLayout = ({ currentSectionIndex }: { currentSectionIndex: string }) => {
  const { hasHumanLedCoachingPrograms, hasStandaloneAIPrograms, isLoading } = useDashboard();

  if (isLoading) {
    return <Skeleton width="100%" height="100vh"></Skeleton>;
  }

  if (!hasHumanLedCoachingPrograms && !hasStandaloneAIPrograms) {
    return <DashboardSectionsNoInsightsLayout />;
  }
  return (
    <SplitLayout sideContent={<DashboardSidebar currentSectionIndex={currentSectionIndex} />}>
      <StyledColumn>
        <DashboardSections currentSectionIndex={currentSectionIndex} />
        <Footer />
      </StyledColumn>
    </SplitLayout>
  );
};
